
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { signOut } from 'aws-amplify/auth'; // AWS Amplify signOut

import { logoutUser } from "../../slices/thunks";

// Importing additional components from CoverLogout
import { Card, Col, Container, Row } from 'reactstrap';
import AuthSlider from '../AuthenticationInner/authCarousel';
import { clearProfile } from "../../slices/auth/profile/reducer";

const Logout = (props) => {
  const dispatch = useDispatch();
  const [isLoggedOut, setIsLoggedOut] = useState(false); // New state to track logout status

  useEffect(() => {
    const performSignOut = async () => {
      try {
        await signOut({ global: true }); // Sign out globally
        dispatch(clearProfile())
        dispatch(logoutUser()); // Dispatch Redux logout action
        setIsLoggedOut(true); // Set state to true after successful logout
      } catch (error) {
        console.log('Error signing out:', error);
      }
    };

    performSignOut();
  }, [dispatch]);

  // Once the user is logged out, show the CoverLogout content
  if (isLoggedOut) {
    document.title = "Media Pulse | Logout"; // Set page title

    return (
      <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
        <div className="bg-overlay"></div>
        <div className="auth-page-content overflow-hidden pt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <Card className="overflow-hidden">
                  <Row className="justify-content-center g-0">
                    <AuthSlider />
                    <Col lg={6}>
                      <div className="p-lg-5 p-4 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/hzomhqxz.json"
                          trigger="loop"
                          colors="primary:#405189,secondary:#08a88a"
                          style={{ width: "180px", height: "180px" }}>
                        </lord-icon>

                        <div className="mt-4 pt-2">
                          <h5>You are Logged Out</h5>
                          <p className="text-muted">
                            Thank you for using <span className="fw-semibold">Media Pulse</span>
                          </p>
                          <div className="mt-4">
                            <Link to="/login" className="btn btn-success w-100">Sign In</Link>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        <footer className="footer">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center">
                  <p className="mb-0">
                    &copy; {new Date().getFullYear()} Whistlemind Technologies LLP. Crafted with{" "}
                    <i className="mdi mdi-heart text-danger"></i>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    );
  }

  // If the user is not logged out yet, return an empty fragment
  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default Logout;
